document.addEventListener('DOMContentLoaded', function () {
  let swiper_testimonials_elm = document.querySelector('.swiper-testimonials');
  if (swiper_testimonials_elm) {
    const swiperTestimonials = new Swiper(swiper_testimonials_elm, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      effect: "creative",
      autoplay: {
        delay: 5500,
        disableOnInteraction: true,
      },
      speed: 1000,
      creativeEffect: {
        prev: {
          opacity: 0,
          translate: ['-50%', 0, -2000],
        },
        next: {
          translate: ["100%", 0, 100],
        },
      },
      pagination: {
        el: '.pagination--testimonials .swiper-pagination',
        clickable: true,
      },
    });
  }
});
